import './BarraProgresso.css';

interface BarraProgressoProps {
  value: number;
  label?: string;
}

function BarraProgresso({ value, label }: BarraProgressoProps) {
  const clampedValue = Math.min(100, Math.max(0, Math.round(value)));

  return (
    <div className="barra-progresso-container">
      {label && <span className="barra-progresso-label">{label}</span>}
      <div
        className="barra-progresso-track"
        role="progressbar"
        aria-valuenow={clampedValue}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={label || 'Progresso'}
      >
        <div
          className="barra-progresso-fill"
          style={{ width: `${clampedValue}%` }}
        />
      </div>
      <span className="barra-progresso-value">{clampedValue}%</span>
    </div>
  );
}

export default BarraProgresso;
